import React, { useState } from "react";
import Config from "../../config/Config";
import HeaderSearch from "../enterprise/com/HeaderSearch";
import List from "./com/list";

import './index.scss'

const Profession = (props) =>
{
    const [loading, setLoading] = useState(false);

    const options = {
        addonBefore: "职业树",
        placeholder: "搜索职业称",
        labelWidth: '80px',
    };
    const conditionList = [
        { label: "职业分类", props: "profession", options: [] },
        { label: "二级分类", props: "second", options: [] },
    ];

    const onSearch = (value) =>
    {};

    return (
        <div component-data={Config.getSourcePath()} className="profession-wrap">
            <HeaderSearch 
                options={options}
                conditionList={conditionList}
                onSearch={(value) => onSearch(value)}
                loading={loading}
            />
            <List 
                history={props.history}
            />
        </div>
    );
}

export default Profession;